{
  "header": {
    "welcomeMessage": "Bienvenue, {{firstName}} !",
    "description": "Examinez et analysez les réponses précédentes aux retours"
  },
  "emptyState": {
    "company": {
      "title": "Aucune donnée collectée pour le moment",
      "description": "Votre parcours commence ici ! Une fois que les employés auront commencé à partager leurs retours durant le premier mois, vous verrez apparaître des insights et des tendances"
    },
    "directReports": {
      "title": "Aucun subordonné direct",
      "description": "Vous n'avez aucun subordonné direct assigné, mais vous pouvez quand même participer aux enquêtes et partager des retours précieux !",
      "bottomAction": {
        "label": "Si vous pensez qu’il s’agit d’une erreur, contactez votre responsable",
        "helpText": "Texte d’aide"
      }
    }
  },
  "tabs": {
    "company": "Entreprise entière",
    "allReports": "Tous les rapports",
    "directReports": "Rapports directs",
    "myTeam": "Mon équipe"
  },
  "keysInsights": {
    "title": "Principaux enseignements",
    "strengths": {
      "title": "Forces",
      "tooltipTitle": "Texte d'aide"
    },
    "growthAreas": {
      "title": "Axes d'amélioration",
      "tooltipTitle": "Texte d'aide"
    }
  },
  "enps": {
    "title": "eNPS",
    "chart": {
      "description": "L'eNPS mesure la probabilité que les employés recommandent leur lieu de travail, reflétant l'engagement et la satisfaction globaux"
    },
    "scoreTitle": "Votre équipe",
    "companyAverageTitle": "eNPS de l'entreprise"
  },
  "overview": {
    "title": "Aperçu",
    "scoreTitle": "Votre équipe",
    "companyAverageTitle": "Moyenne de l'entreprise"
  }
}
